import React from "react";

import { format } from "date-fns";

import { Box, Grid, InputAdornment, Tooltip } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";

import {
  ArrayField,
  ArrayInput,
  BooleanField,
  BooleanInput,
  Datagrid,
  FormDataConsumer,
  Labeled,
  required,
  SimpleFormIterator,
  TextField,
  TextInput,
} from "react-admin";

const validateRequired = required();

const formatDateTime = (value) => {
  // return new Date(value).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  return format(new Date(value), "MM/dd/yyyy hh:mm a");
};

export const NotesTab = (props) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <ArrayInput source="notes" label="NOTES" variant="outlined" fullWidth>
          <SimpleFormIterator disableReordering>
            <FormDataConsumer>
              {({
                formData, // The whole form data
                scopedFormData, // The data for this item of the ArrayInput
                getSource, // Function to get the valid source inside an ArrayInput. Translates to "notes.items[].property"
                ...rest
              }) => (
                <Box flex={1}>
                  <TextInput
                    source={getSource("text")}
                    label=""
                    variant="outlined"
                    multiline
                    fullWidth
                    minRows={scopedFormData?.date ? "" : "3"}
                    disabled={scopedFormData?.date ? true : undefined}
                    validate={validateRequired}
                    helperText={
                      scopedFormData?.date
                        ? `Added: ${formatDateTime(scopedFormData.date)} By: ${
                            scopedFormData.by
                          }`
                        : false
                    }
                    InputProps={
                      scopedFormData?.date && scopedFormData?.public
                        ? {
                            endAdornment: (
                              <InputAdornment position="end">
                                <Tooltip title="Public" placement="left" arrow>
                                  <VisibilityIcon />
                                </Tooltip>
                              </InputAdornment>
                            ),
                          }
                        : {}
                    }
                  />
                  {!scopedFormData?.date && (
                    <BooleanInput source={getSource("public")} label="Public" />
                  )}
                </Box>
              )}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </Grid>
  );
};

export const NotesTabShow = ({
  hidePrivate = false,
  // Callers that already title the notes themselves — a section header, a tab
  // label — would otherwise show the word twice.
  hideLabel = false,
  record,
  ...props
}) => {
  // Ensure that record.notes is an array
  const notes = Array.isArray(record.notes) ? record.notes : [];

  // Filter the notes based on hidePrivate parameter
  const filteredNotes = hidePrivate
    ? notes.filter((note) => note.public)
    : notes;

  // Create a new record with the filtered notes
  const notesRecord = { notes: filteredNotes };

  const notesGrid = (
    <ArrayField source="notes" record={notesRecord}>
      <Datagrid>
        <TextField source="text" />
        <TextField source="date" />
        <TextField source="by" />
        {!hidePrivate && <BooleanField source="public" />}
      </Datagrid>
    </ArrayField>
  );

  return hideLabel ? (
    notesGrid
  ) : (
    <Labeled label="NOTES" fullWidth>
      {notesGrid}
    </Labeled>
  );
};
